import React from "react";
import { FormGroup, FormControl, ControlLabel } from "rsuite";
import styled from "styled-components";


const CustomField = ({ name, message, label, widthLabel, accepter, error, formGroupExtraStyle, ...props }) => {
    const formGroupStyle = formGroupExtraStyle ? formGroupExtraStyle : { marginBottom: 10, width: "100%" };
    return (
        <FormGroup className={error ? "has-error" : ""} style={formGroupStyle}>
            {label &&
                <ControlLabel style={{ width: "100%", textAlign: "left", display: "block" }}>{label}</ControlLabel>
            }
            <StyledFieldWrapper>
                <FormControl
                    name={name}
                    accepter={accepter}
                    errorMessage={error}
                    errorPlacement="topRight"
                    {...props}
                />
            </StyledFieldWrapper>
        </FormGroup>
    );
};

export default CustomField;

const StyledFieldWrapper = styled.div`
    max-width: 250px;
`;